export default {
  invoice_raw: 'Счет',
  TN_raw: 'ТН',
  TTN_raw: 'ТТН',
  protocol_raw: 'Протокол'
}
